import Link from "next/link"
import { Wind, Instagram, Facebook, Youtube } from "lucide-react"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"

const footerLinks = {
  Shop: [
    { label: "All Coffees", href: "/shop" },
    { label: "Subscriptions", href: "/subscribe" },
    { label: "Gift Cards", href: "/shop/gifts" },
    { label: "Merchandise", href: "/shop/merch" },
  ],
  Visit: [
    { label: "Café Locations", href: "/locations" },
    { label: "Cupping Events", href: "/events" },
    { label: "Brewing Guides", href: "/guides" },
  ],
  Company: [
    { label: "Our Story", href: "/about" },
    { label: "Origin Stories", href: "/blog" },
    { label: "Wholesale", href: "/wholesale" },
    { label: "FAQ", href: "/faq" },
    { label: "Contact", href: "/contact" },
  ],
}

export default function Footer() {
  return (
    <footer className="bg-foreground text-background">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        {/* Top row */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 pb-12 border-b border-background/10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-full bg-primary flex items-center justify-center">
                <Wind className="w-5 h-5 text-primary-foreground" />
              </div>
              <div className="flex flex-col leading-none">
                <span className="font-heading font-bold text-[15px]">Northwind</span>
                <span className="text-[10px] text-background/50 tracking-[0.15em] uppercase">Coffee Roasters</span>
              </div>
            </div>
            <p className="text-sm text-background/60 leading-relaxed max-w-xs mb-6">
              Small-batch specialty coffee roasted in Portland, OR. We source directly from small farms and roast with
              intention.
            </p>
            {/* Newsletter */}
            <p className="text-xs uppercase tracking-widest text-background/40 mb-3">Join our list</p>
            <div className="flex gap-2">
              <Input
                type="email"
                placeholder="your@email.com"
                className="bg-background/10 border-background/20 text-background placeholder:text-background/30 text-sm h-9"
              />
              <Button size="sm" className="bg-primary hover:bg-primary/90 text-primary-foreground h-9 px-4 shrink-0">
                Subscribe
              </Button>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([group, links]) => (
            <div key={group}>
              <p className="text-xs uppercase tracking-widest text-background/40 mb-4">{group}</p>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.href}>
                    <Link
                      href={link.href}
                      className="text-sm text-background/60 hover:text-primary transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-xs text-background/40">
            © {new Date().getFullYear()} Northwind Coffee Roasters. Portland, OR. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link href="#" aria-label="Instagram" className="text-background/40 hover:text-primary transition-colors">
              <Instagram className="w-4 h-4" />
            </Link>
            <Link href="#" aria-label="Facebook" className="text-background/40 hover:text-primary transition-colors">
              <Facebook className="w-4 h-4" />
            </Link>
            <Link href="#" aria-label="YouTube" className="text-background/40 hover:text-primary transition-colors">
              <Youtube className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
